var hideSearchTray;
toggleSearchTray = () => {
  const searchTrigger = document.querySelector('.search-trigger');

  const searchTray = document.querySelector('.search-tray');
  const searchForm = searchTray.querySelector('.search-form');
  const searchInput = searchTray.querySelector('input');
  const backdrop = document.querySelector('.search-backdrop');

  const state = {
    reversed: true
  };

  gsap.set(searchTray, { yPercent: -100, force3D: true });

  searchTrigger.addEventListener('click', () => {
    if (megaMenuOpen) {
      reverseMegaMenu();
    }
    if (state.reversed) {
      state.reversed = false;
      gsap.to(backdrop, 0.4, { autoAlpha: 1, ease: Sine.easeInOut, force3D: true });
      gsap.to(searchTray, 0.8, { yPercent: 0, ease: Expo.easeOut, force3D: true });
      searchInput.focus()
      if ($scroll) {
        $scroll.lockScroll()
      }
      // if (miniCartDrawer) {
      // 	miniCartDrawer.close()
      // }
    } else {
      state.reversed = true;
      gsap.to(backdrop, 0.4, { autoAlpha: 0, ease: Sine.easeOut, force3D: true });
      gsap.to(searchTray, 0.8, { yPercent: -100, ease: Expo.easeOut, force3D: true });
      if ($scroll) {
        $scroll.unlockScroll()
      }
    }
  });

  hideSearchTray = () => {
    if (!state.reversed) {
      state.reversed = true;
      gsap.to(backdrop, 0.4, { autoAlpha: 0, ease: Sine.easeOut, force3D: true });
      gsap.to(searchTray, 0.8, { yPercent: -100, ease: Expo.easeOut, force3D: true });
      searchForm.classList.remove('focused');
    }
  };

  backdrop.addEventListener('click', () => {
    hideSearchTray();
  });

  searchInput.addEventListener('focus', () => {
    searchForm.classList.add('focused');
  });

  searchInput.addEventListener('blur', () => {
    searchForm.classList.remove('focused');
  });

};